import React, { useEffect, useState, useRef } from "react";
import "./Templatelisting.css";
import searchbtn from "../../../Assets/images/search.svg";
import Pagination from "../../Pagination/Pagination";
import deleteimg from "../../../Assets/images/delete-img.png";
import { useNavigate } from "react-router-dom";
import {
  hideLoader,
  showLoader,
} from "../../../Redux/Slice/Loader/loaderSlice";
import { useDispatch, useSelector } from "react-redux";
import showToast from "../../../Utils/Toast/ToastNotification";
import { HandleApiError } from "../../../Utils/CommonErrors/HandleApiError";
import TemplateService from "../../../Services/TemplateService/TemplateService";
import { Modal } from "bootstrap";

const Templatelisting = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const modalRef = useRef(null);
  const createdFromDateRef = useRef(null);
  const createdToDateRef = useRef(null);

  const user_id = useSelector(
    (state) => state.auth?.user?.data?.body?.data?.userData?.id
  );

  const token = useSelector(
    (state) => state.auth?.user?.data?.body?.data?.token
  );

  const [selectedId, setSelectedId] = useState(null);
  const [selectedTemplateId, setSelectedTemplateId] = useState(null);
  const [totalRecords, setTotalRecords] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [sortBy, setSortBy] = useState("created_at");
  const [sortOrder, setSortOrder] = useState("ASC");
  const [searchQuery, setSearchQuery] = useState("");
  const [template, setTemplate] = useState([]);
  const [isFilterCleared, setIsFilterCleared] = useState(false);
  const [filters, setFilters] = useState({
    page: 1,
    limit: 10,
    start_date_from: "",
    start_date_to: "",
  });
  const [showArchived, setShowArchived] = useState(false);

  const openModal = () => {
    if (modalRef.current) {
      const modalInstance = new Modal(modalRef.current, { backdrop: "static" });

      const oldInstance = Modal.getInstance(modalRef.current);
      if (oldInstance) {
        oldInstance.dispose();
      }
      const newInstance = new Modal(modalRef.current, { backdrop: "static" });
      newInstance.show();
    }
  };

  const handleFocus = (ref) => {
    if (ref.current) {
      ref.current.showPicker?.(); // Open date picker if supported
    }
  };

  const handleFilterChange = (e) => {
    const { id, value } = e.target;
    setFilters((prevFilters) => ({
      ...prevFilters,
      [id]: value,
    }));
  };

  const handleFilterSubmit = (e) => {
    e.preventDefault();
    getTemplateList();
  };

  const handleClearFilter = (e) => {
    e.preventDefault();

    setFilters({
      start_date_from: "",
      start_date_to: "",
      page: page + 1,
      limit: rowsPerPage,
    });

    setIsFilterCleared(true);
    setSearchQuery("");
    if (createdFromDateRef.current) createdFromDateRef.current.value = "";
    if (createdToDateRef.current) createdToDateRef.current.value = "";
    // getTemplateList(); this call double api 
  };

  const handleChangePage = (newPage) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (e) => {
    setRowsPerPage(e.target.value);
    setPage(0);
  };

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
    setPage(0);
  };

  const handleSort = (column) => {
    if (sortBy === column) {
      setSortOrder(sortOrder === "ASC" ? "DESC" : "ASC");
    } else {
      setSortBy(column);
      setSortOrder("ASC");
    }
  };

  const handleDelete = async () => {
    try {
      const params = {
        template_id: selectedId,
        deleted_by: user_id,
      };
      const response = await TemplateService.deleteTemplate(params, token);
      showToast("success", response.data.body.message);
      await getTemplateList();
    } catch (error) {
      HandleApiError(error);
    }
  };

  const getTemplateList = async () => {
    dispatch(showLoader());
    const params = {
      search: searchQuery || "",
      page: page + 1,
      limit: rowsPerPage,
      sort_by: `"${sortBy}"`,
      sort_order: sortOrder,
      start_date_from: filters.start_date_from || "",
      start_date_to: filters.start_date_to || "",
      is_archived: showArchived ? "" : "false",
    };
    try {
      const response = await TemplateService.getTemplates(params, token);
      if (response?.data?.statusCode == 200) {
        const templateList = response?.data?.body?.data?.templates || [];
        const totalItems = response?.data?.body?.data?.total || 0;

        if (templateList.length === 0 && page > 0) {
          setPage((prev) => prev - 1);
        } else {
          setTemplate(templateList);
          setTotalRecords(totalItems);
        }
      } else {
        showToast("error", response.data.body?.message);
      }
    } catch (error) {
      await HandleApiError(error);
    } finally {
      dispatch(hideLoader());
    }
  };

  const cloneTemplate = async () => {
    try {
      const response = await TemplateService.cloneTemplate({ id: selectedId }, token);
      if (response?.data.statusCode === 200) {
        showToast("success", response.data.body.message);
        getTemplateList();
      } else {
        showToast("error", response.body.message);
      }
      await getTemplateList();
    } catch (error) {
      await HandleApiError(error);
    }
  };

  const handleArchive = async () => {
    try {

      await dispatch(showLoader());
      const params = {
        id: selectedTemplateId,
        deleted_by: user_id,
      }
      const response = await TemplateService.archiveTemplate(params, token);
      if (response?.data.statusCode === 200) {
        showToast("success", response.data.body.message);
        getTemplateList();
      }
    } catch (error) {
      HandleApiError(error)
    }
    finally {
      await dispatch(hideLoader());
    }
  }

  useEffect(() => {
    getTemplateList();
  }, [debouncedSearch, page, rowsPerPage, sortBy, sortOrder]);

  useEffect(() => {
    if (isFilterCleared) {
      getTemplateList();
      setIsFilterCleared(false);
    }
  }, [isFilterCleared]);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      setDebouncedSearch(searchQuery);
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [searchQuery]);

  useEffect(() => {
    getTemplateList();
  }, [showArchived]);

  return (
    <div className="main-inner-block">
      <div className="content">
        <div className="d-flex align-items-center justify-content-between mb-4 block-one gap-3">
          <div className="heading-content ms-0 mt-0">Template Listing</div>
          <div className="heading-content mt-0">
            <button
              className="green-btn green-signin addnewuser"
              onClick={() => navigate("/add-template")}
            >
              + Add Template
            </button>
          </div>
        </div>
        <div className="white-box bg-box-mob">
          <div className="inner-content-block">
            <div className="listing-title-block d-flex justify-content-between">
              <div className="box-listing-title">
                Template Details
                <span className="d-block">
                  Showing a list of Template detail.
                </span>
              </div>
              <div className="searchbar-btn d-flex align-items-center gap-4">
                <div className="toggle-archive d-flex align-items-center">
                  <label
                    className="form-check-label me-2"
                    htmlFor="archiveToggle"
                  >
                    Show Archived
                  </label>
                  <div className="form-check form-switch">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="archiveToggle"
                      checked={showArchived}
                      onChange={(e) => setShowArchived(e.target.checked)}
                    />
                  </div>
                </div>

                <div className="input-search-box position-relative">
                  <input
                    type="text"
                    id="name"
                    placeholder="Search"
                    value={searchQuery}
                    onChange={handleSearch}
                  />
                  <div className="searchbtn">
                    <img src={searchbtn} alt="searchbtn"></img>
                  </div>
                  {searchQuery && (
                    <button
                      className="clear-btn"
                      onClick={() => setSearchQuery("")}
                    >
                      ✖
                    </button>
                  )}
                </div>
                <div className="filter d-flex align-items-center gap-4">
                  <a
                    className="filter-inner"
                    href="#"
                    data-bs-toggle="modal"
                    data-bs-target="#exampleModal"
                    onClick={(e) => {
                      e.preventDefault();
                      openModal();
                    }}
                  >
                    <span className="me-2">
                      <svg
                        width="20"
                        height="21"
                        viewBox="0 0 20 21"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M5 10.332H15M2.5 5.33203H17.5M7.5 15.332H12.5"
                          stroke="#475467"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>
                    Filter
                  </a>
                  <div
                    class="modal fade"
                    id="exampleModal"
                    tabindex="-1"
                    aria-labelledby="exampleModalLabel"
                    aria-hidden="true"
                  >
                    <div class="modal-dialog modal-dialog-centered">
                      <div class="modal-content">
                        <div className="text-end">
                          <button
                            type="button"
                            class="btn-close "
                            data-bs-dismiss="modal"
                            aria-label="Close"
                          ></button>
                        </div>

                        <div>
                          <h1
                            class="modal-title fs-5 text-center filter-title"
                            id="exampleModalLabel"
                          >
                            Template Filter
                          </h1>
                        </div>
                        <div class="modal-body">
                          <form
                            onSubmit={(e) => {
                              e.preventDefault();
                              getTemplateList();
                            }}
                          >
                            <div class="mb-3">
                              <label
                                htmlFor="start_date_from"
                                className="form-label"
                              >
                                Date Created
                              </label>

                              <div className="d-flex gap-2">
                                <input
                                  type="date"
                                  className="form-control"
                                  id="start_date_from"
                                  name="start_date_from"
                                  ref={createdFromDateRef}
                                  onChange={handleFilterChange}
                                  onClick={() =>
                                    handleFocus(createdFromDateRef)
                                  }
                                  placeholder="From"
                                />{" "}
                                <span>-</span>
                                <input
                                  type="date"
                                  className="form-control"
                                  id="start_date_to"
                                  name="start_date_to"
                                  ref={createdToDateRef}
                                  onChange={handleFilterChange}
                                  onClick={() =>
                                    handleFocus(createdToDateRef)
                                  }
                                  placeholder="To"
                                />
                              </div>
                            </div>
                            <div className="text-center">
                              <button
                                type="submit"
                                class="green-btn updt-button"
                                data-bs-dismiss="modal"
                                onClick={(e) => handleFilterSubmit(e)}
                              >
                                Filter
                              </button>
                              <button
                                type="button"
                                class="green-btn updt-button ms-2"
                                data-bs-dismiss="modal"
                                onClick={handleClearFilter}
                              >
                                Clear Filter
                              </button>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="table-block">
              <table class="table">
                <thead class="table-headers">
                  <tr>
                    <th onClick={() => handleSort("template_name")}>
                      Template Name
                      <span className="ms-1">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          width="10"
                          height="17"
                          viewBox="0 0 32 32"
                        >
                          <g>
                            <path
                              d="M7 13h18a1 1 0 0 0 .707-1.707l-9-9a1 1 0 0 0-1.414 0l-9 9A1 1 0 0 0 7 13zM25 19H7a1 1 0 0 0-.707 1.707l9 9a1 1 0 0 0 1.414 0l9-9A1 1 0 0 0 25 19z"
                              fill="#949494"
                              opacity="1"
                            />
                          </g>
                        </svg>
                      </span>
                    </th>
                    <th onClick={() => handleSort("template_number")}>
                      Template Description
                    </th>
                    <th>Tags</th>

                    <th onClick={() => handleSort("created_at")}>
                      Date Created
                      <span className="ms-1">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          width="10"
                          height="17"
                          viewBox="0 0 32 32"
                        >
                          <g>
                            <path
                              d="M7 13h18a1 1 0 0 0 .707-1.707l-9-9a1 1 0 0 0-1.414 0l-9 9A1 1 0 0 0 7 13zM25 19H7a1 1 0 0 0-.707 1.707l9 9a1 1 0 0 0 1.414 0l9-9A1 1 0 0 0 25 19z"
                              fill="#949494"
                              opacity="1"
                            />
                          </g>
                        </svg>
                      </span>
                    </th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {template.length > 0 ? (
                    template.map((template, index) => (
                      <tr key={template.id}>
                        <td>
                          <a className="name-email-text"
                            onClick={() => navigate(`/view-template/${template.id}`)}
                          >
                            {template.template_name}
                          </a>
                        </td>
                        <td>
                          <div
                            className="text-truncate"
                            style={{ width: '200px' }}
                          >
                            {template.description}
                          </div>
                        </td>
                        <td>
                          {template.tags ? template.tags?.join(", ") : "-"}
                        </td>
                        <td
                          style={{
                            textAlign: template.created_at ? "left" : "center",
                          }}
                        >
                          {template.created_at
                            ? new Date(template.created_at).toLocaleDateString()
                            : "-"}
                        </td>
                        <td>
                          <div className="d-flex gap-3">
                            <a
                              className="tooltip-container d-flex align-items-center text-decoration-none fonticon"
                              onClick={() =>
                                navigate(`/view-template/${template.id}`)
                              }
                            >
                              <i className="fas fa-eye me-2"></i>
                              <span className="tooltip-text">View</span>
                            </a>

                            <a
                              className="tooltip-container d-flex align-items-center text-decoration-none fonticon"
                              onClick={() =>
                                navigate(`/update-template/${template.id}`)
                              }
                            >
                              <i className="fas fa-pencil-alt me-2"></i>
                              <span className="tooltip-text">Update</span>
                            </a>

                            {/* <a
                              className="tooltip-container d-flex align-items-center text-decoration-none fonticon"
                              onClick={() =>
                                navigate(`/start-inspection/${template.id}`)
                              }
                            >
                              <i className="fas fa-plus me-2"></i>
                            </a> */}
                            <a
                              className="tooltip-container d-flex align-items-center text-decoration-none fonticon"
                              href="#"
                              data-bs-toggle="modal"
                              data-bs-target="#deletemodal"
                              onClick={() => setSelectedId(template.id)}
                            >
                              <i className="fas fa-trash me-2"></i>
                              <span className="tooltip-text">Delete</span>
                            </a>

                            <a
                              className="tooltip-container d-flex align-items-center text-decoration-none fonticon"
                              href="#"
                              data-bs-toggle="modal"
                              data-bs-target="#archiveemodal"
                              onClick={() => setSelectedTemplateId(template.id)}
                            >
                              <i class="fa fa-archive" aria-hidden="true"></i>
                              <span className="tooltip-text">Archive</span>
                            </a>
                            <a
                              className="tooltip-container d-flex align-items-center text-decoration-none fonticon"
                              href="#"
                              data-bs-toggle="modal"
                              data-bs-target="#cloneModel"
                              onClick={() => setSelectedId(template.id)}
                            >
                              <i class="fa-solid fa-clone"></i>
                              <span className="tooltip-text">Clone</span>
                            </a>



                            {/* Clone Confirmation Model */}

                            <div
                              class="modal fade"
                              id="cloneModel"
                              tabindex="-1"
                              aria-labelledby="deletemodalLabel"
                              aria-hidden="true"
                            >
                              <div class="modal-dialog modal-dialog-centered delete-modal">
                                <div class="modal-content">
                                  <div class="modal-body">
                                    <div className="ques-title text-center">
                                      Are you sure ?
                                      <p className="m-0">
                                        Do you want to clone the Template
                                        record?
                                      </p>
                                    </div>
                                  </div>
                                  <div className="d-flex align-items-center justify-content-center gap-3 btn-block">
                                    <button
                                      type="button"
                                      class="gray-outline-btn"
                                      data-bs-dismiss="modal"
                                    >
                                      Cancel
                                    </button>
                                    <button
                                      type="button"
                                      class="orange-btn"
                                      data-bs-dismiss="modal"
                                      onClick={cloneTemplate}
                                    >
                                      Yes
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="7" className="text-center">
                        No Templates found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* responsive  */}
            <div className="mobile-table-card d-block d-md-none">
              {template?.length > 0
                ? (
                  template.map((template) => (
                    <div key={template.id} className="user-card">
                      <div className="data-card mb-3 p-3 border rounded">
                        <div className="mb-2">
                          <strong>Name:</strong>{template.template_name}
                        </div>
                        <div className="mb-2">
                          <strong>Description:</strong>{template.description}
                        </div>
                        <div className="mb-2">
                          <strong>Tags:</strong>{template.tags?.length ? template.tags?.join(", ") : " -"}
                        </div>
                        <div className="mb-2">
                          <strong>Date Created:</strong>{template.created_at
                            ? new Date(template.created_at).toLocaleDateString()
                            : "-"}
                        </div>

                        <div className="d-flex justify-content-end mt-3 gap-3">
                          <a
                            className="d-flex align-items-center text-decoration-none fonticon"
                            onClick={() =>
                              navigate(`/view-template/${template.id}`)
                            }
                          >
                            <i className="fas fa-eye me-2"></i>
                          </a>
                          <a
                            className="d-flex align-items-center text-decoration-none fonticon"
                            onClick={() =>
                              navigate(`/update-template/${template.id}`)
                            }
                          >
                            <i className="fas fa-pencil-alt me-2"></i>
                          </a>
                          <a
                            className="d-flex align-items-center text-decoration-none fonticon"
                            href="#"
                            data-bs-toggle="modal"
                            data-bs-target="#deletemodal"
                            onClick={() => setSelectedId(template.id)}
                          >
                            <i className="fas fa-trash me-2"></i>
                          </a>

                          <a
                            className="tooltip-container d-flex align-items-center text-decoration-none fonticon"
                            href="#"
                            data-bs-toggle="modal"
                            data-bs-target="#archiveemodal"
                            onClick={() => setSelectedTemplateId(template.id)}
                          >
                            <i class="fa fa-archive" aria-hidden="true"></i>
                          </a>

                          <a
                            className="tooltip-container d-flex align-items-center text-decoration-none fonticon"
                            href="#"
                            data-bs-toggle="modal"
                            data-bs-target="#cloneModel1"
                            onClick={() => setSelectedId(template.id)}
                          >
                            <i class="fa-solid fa-clone"></i>
                          </a>


                          <div
                            class="modal fade"
                            id="cloneModel1"
                            tabindex="-1"
                            aria-labelledby="deletemodalLabel"
                            aria-hidden="true"
                          >
                            <div class="modal-dialog modal-dialog-centered delete-modal">
                              <div class="modal-content">
                                <div class="modal-body">
                                  <div className="ques-title text-center">
                                    Are you sure ?
                                    <p className="m-0">
                                      Do you want to clone the Template
                                      record?
                                    </p>
                                  </div>
                                </div>
                                <div className="d-flex align-items-center justify-content-center gap-3 btn-block">
                                  <button
                                    type="button"
                                    class="gray-outline-btn"
                                    data-bs-dismiss="modal"
                                  >
                                    Cancel
                                  </button>
                                  <button
                                    type="button"
                                    class="orange-btn"
                                    data-bs-dismiss="modal"
                                    onClick={cloneTemplate}
                                  >
                                    Yes
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  ))
                )
                : (
                  <div className="text-center">
                    No Template Found
                  </div>
                )
              }
            </div>

            <div className="pagination-block">
              {
                <Pagination
                  count={totalRecords}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onChangePage={handleChangePage}
                  onRowsPerPageChange={handleRowsPerPageChange}
                />
              }
            </div>
          </div>
        </div>

        {/* archive modal */}
        <div
          class="modal fade"
          id="archiveemodal"
          tabindex="-1"
          aria-labelledby="archiveemodalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-dialog-centered delete-modal">
            <div class="modal-content">
              <div class="modal-body">
                <div className="text-center delete-img-blk">
                  <img src={deleteimg} alt="delete-img"></img>
                </div>
                <div className="ques-title text-center">
                  Are you sure ?
                  <p className="m-0">
                    Are you sure you really want to archive this Template?
                  </p>
                </div>
              </div>
              <div className="d-flex align-items-center justify-content-center gap-3 btn-block">
                <button
                  type="button"
                  class="gray-outline-btn"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  class="orange-btn"
                  data-bs-dismiss="modal"
                  onClick={handleArchive}
                >
                  Archive
                </button>
              </div>
            </div>
          </div>
        </div>


        {/* delete modal */}
        <div
          class="modal fade"
          id="deletemodal"
          tabindex="-1"
          aria-labelledby="deletemodalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-dialog-centered delete-modal">
            <div class="modal-content">
              <div class="modal-body">
                <div className="text-center delete-img-blk">
                  <img src={deleteimg} alt="delete-img"></img>
                </div>
                <div className="ques-title text-center">
                  Are you sure ?
                  <p className="m-0">
                    Are you sure you really want to delete this record? This
                    process cannot be undone.
                  </p>
                </div>
              </div>
              <div className="d-flex align-items-center justify-content-center gap-3 btn-block">
                <button
                  type="button"
                  class="gray-outline-btn"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  class="orange-btn"
                  data-bs-dismiss="modal"
                  onClick={handleDelete}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div >

  );
};

export default Templatelisting;
